import React from 'react';
import { Card } from 'react-bootstrap';
import { LocationPermissionsTitle, LocationPermissionsTitleSpan, LocationPermissionsText, CardSubtext } from './blocks';
import { useMutation } from '@apollo/client';
import { css } from '@emotion/react';
import { useClientUser } from '@/hooks';
import { Grid, MenuItem, TextField } from '@material-ui/core';
import { OnwardToggle } from '../ShipmentForm/blocks';
import { UPDATE_USER } from './mutations';

export default function Communications({ comms }) {
    const { client_id, circles } = useClientUser();

    const [updateUser] = useMutation(UPDATE_USER);

    const toggleFlag = (flag) => {
        const next = {
            ...(circles || {}),
            [flag]: !circles?.[flag],
        };
        updateUser({ variables: { user_id: client_id, update: { circles: next } } });
    };

    const setFlag = (flag, value) => {
        const next = {
            ...(circles || {}),
            [flag]: value,
        };
        updateUser({ variables: { user_id: client_id, update: { circles: next } } });
    };

    return (
        <>
            <Card
                css={css`
                    margin-top: 30px;
                `}
            >
                <Card.Body
                    css={css`
                        padding: 28px 26px 28px 26px;
                    `}
                >
                    <LocationPermissionsTitle>
                        <LocationPermissionsTitleSpan>Communications</LocationPermissionsTitleSpan>
                    </LocationPermissionsTitle>
                    <Grid
                        css={css`
                            display: flex;
                            flex-direction: column;
                            gap: 30px;
                        `}
                    >
                        {comms.map((comm) => (
                            <Grid
                                key={comm.featureFlag}
                                container
                                css={css`
                                    flex-wrap: nowrap;
                                `}
                            >
                                <Grid item>
                                    {comm.type === 'select' ? (
                                        <TextField
                                            select
                                            size="small"
                                            variant="outlined"
                                            value={circles?.[comm.featureFlag] ?? comm.defaultValue ?? ''}
                                            onChange={(e) => setFlag(comm.featureFlag, e.target.value)}
                                            css={css`
                                                min-width: 180px;
                                            `}
                                        >
                                            {comm.options.map((opt) => (
                                                <MenuItem key={opt.value} value={opt.value}>
                                                    {opt.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    ) : (
                                        <OnwardToggle
                                            value={!!circles?.[comm.featureFlag]}
                                            onChange={() => toggleFlag(comm.featureFlag)}
                                        />
                                    )}
                                </Grid>
                                <Grid
                                    item
                                    container
                                    direction="column"
                                    css={css`
                                        margin-left: 13px;
                                    `}
                                >
                                    <Grid item>
                                        <LocationPermissionsText>{comm.display}</LocationPermissionsText>
                                    </Grid>
                                    <Grid item>
                                        <CardSubtext>{comm.description}</CardSubtext>
                                    </Grid>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </Card.Body>
            </Card>
        </>
    );
}
